import { Component, OnInit } from '@angular/core';
import { environment, envtemplate } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public envtemplate = envtemplate;
  constructor() { }

  ngOnInit(): void {
  }

}
